import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { RootState } from "../../store/combineReducer";
import AbsenteesReports from "../Results/absentees-reports";
import History from "./history";
import AbsenceInLavoris from "./absenceInLavoris";
import { AbsencesRequest } from "./solicitudes";

const Ausentismo = () => {
  const reduxStore = useSelector((state: RootState) => state.user);
  const chosenRole: string = reduxStore?.currentRole;
  const CUENTA: any = {
    COMPANY_ADMIN: <CompanyAbsences />,
    RRHH_ABSENTEE: <CompanyAbsences />,
    ADM_ABSENTEE: <CompanyAbsences />,
    RRHH: <CompanyAbsences />,
    RRHH_APPOINTMENTS_AND_ABSENTEE: <CompanyAbsences />,
    RRHH_RESULT: <CompanyAbsences />,
  };
  return CUENTA[chosenRole] ? CUENTA[chosenRole] : <></>;
};

const CompanyAbsences = () => {
  const [searchParams, setSearchParams] = useSearchParams("");
  const reduxStore = useSelector((state: RootState) => state.user);
  const chosenRole: string = reduxStore?.currentRole;
  const [currentTab, setCurrentTab] = useState(
    chosenRole !== "RRHH_RESULT" ? "Solicitudes" : "Resultados"
  );

  useEffect(() => {
    const currentTable = searchParams.get("currentTab") || "";
    if (currentTable) setCurrentTab(currentTable);
  }, [searchParams]);

  const handleTabChange = (tab: string) => {
    setCurrentTab(tab);
    setSearchParams({ currentTab: tab });
  };

  const renderTabContent = () => {
    switch (currentTab) {
      case "Turnos":
        return <AbsenceInLavoris />;
      case "Solicitudes":
        return <AbsencesRequest />;
      case "Resultados":
        return <AbsenteesReports />;
      case "Historial":
        return <History />;
      default:
        return null;
    }
  };

  const tabs = [
    { label: "Consultorio", value: "Turnos" },
    { label: "Otras modalidades de control", value: "Solicitudes" },
    { label: "Resultados", value: "Resultados" },
    { label: "Historial", value: "Historial" },
  ];

  // Determinar las pestañas visibles según el rol
  const visibleTabs =
    chosenRole === "RRHH_RESULT"
      ? tabs.filter((tab) => tab.value === "Resultados")
      : chosenRole === "RRHH_APPOINTMENTS_AND_ABSENTEE" || chosenRole === "RRHH_ABSENTEE" ? tabs.filter((tab) => tab.value !== "Resultados")
        : chosenRole === "ADM_ABSENTEE" ? tabs.filter((tab) => tab.value === "Solicitudes")
          : chosenRole === "COMPANY_ADMIN" || chosenRole === "RRHH" || chosenRole === "RRHH_APPOINTMENTS_AND_ABSENTEE" || chosenRole === "RRHH_ABSENTEE"
            ? tabs // Ver todas las pestañas
            : tabs.filter((tab) => tab.value !== "Resultados"); // Otros roles, no muestran Resultados

  return (
    <div className="main-container">
      <div className="atendoo-card">

        <div className="custom-header">
          <div className="header-top">
            <h6 className="subtitle">Ausentismo</h6>
          </div>
        </div>

        <div className="tabs-container">
          <nav className="tabs-nav">
            {visibleTabs.map((tab) => {
              return (
                <button
                  key={tab.value}
                  className={`tab-button ${currentTab === tab.value ? 'active' : ''}`}
                  onClick={() => handleTabChange(tab.value)}
                >
                  <span className="tab-label">{tab.label}</span>
                </button>
              )
            })}
          </nav>
        </div>

        {renderTabContent()}
      </div>
    </div>
  );
};

export default Ausentismo;
